import * as types from './mutation-types'
import { removeToken } from '@/lin/utils/cookie'
import state from './state'


export default {

  setUserAndState({ commit }, user) {
    // 如果登陆成功，设置logined标志位
    commit(types.SET_LOGINED, true)
    // 设置全局用户状态
    commit(types.SET_USER, user)
  },

  loginOut({ commit }) {
    removeToken()
    commit(types.REMOVE_LOGINED, false)
  },

  readMessage({ commit }, message) {
    commit(types.REMOVE_UNREAD_MESSAGE, message.id)
    commit(types.ADD_READED_MESSAGE, message)
  },

  setProject({commit}, project) {
    commit(types.SET_PROJECT, project)
  },

  setFeatures({commit}, features) {
    commit(types.SET_FEATURES, features)
  },

  setFeatureID({commit}, [feature, id]) {
    if(!state.features[feature]) {
      state.features[feature] = {}
    }
    state.features[feature].id = id
    commit(types.SET_FEATURES, state.features)
  },  

  getFeatureID({commit}, feature)  {
    if(state.features[feature]) {
      let fea = state.features[feature]
      if(fea.id != undefined || fea.id != null) {
        return fea.id
      }
    }
    return -1
  }
}
